import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { CancelReservationResponseDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

export const useAdminCancelAndRefundReservation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (reservationId: number): Promise<CancelReservationResponseDto> => {
      const response = await apiFetch(
        `api/admin/reservations/${reservationId}/cancel-and-refund`,
        {
          method: "POST",
        }
      );
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response.json();
    },
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["events"] }),
        queryClient.invalidateQueries({ queryKey: ["reservation-requests", "admin"] }),
      ]),
  });
};
